export default function () {
  return {scripts: {'lint:sensitive': 'ban'}, devDependencies: ['ban-sensitive-files']};
}
